var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"training-add-course"},[_c('table-list',{attrs:{"loading":_vm.loading,"data":_vm.dataList,"columns":_vm.columns(this),"btns":_vm.btns(this),"operates":_vm.operates(this),"options":{ operatesWidth: 170 }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }